// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0588276e","952":"4d2a8e26"}[chunkId] + ".chunk.js";
};